import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from "../context/LanguageContext"; // ✅ Import du contexte

// --- SVG ICONS ---
const Icons = {
  Home: () => (
    <svg className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
    </svg>
  ),
  ArrowLeft: () => (
    <svg className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
    </svg>
  ),
  Ghost: () => (
    <svg className="w-32 h-32 text-indigo-200 mx-auto mb-6 animate-bounce-slow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2C7.58172 2 4 5.58172 4 10V19L6.5 17L9 19.5L12 17L15 19.5L17.5 17L20 19V10C20 5.58172 16.4183 2 12 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 10H9.01" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15 10H15.01" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10 14C10 14 11 15 12 15C13 15 14 14 14 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
};

const NotFound = () => {
  const { t } = useLanguage(); // ✅ Utilisation des traductions

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-4 relative overflow-hidden">
      
      {/* --- DECORATIVE BACKGROUND (Cohérent avec VerifyCertif) --- */}
      <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-indigo-200/30 rounded-full blur-[100px] pointer-events-none"></div>
      <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-emerald-200/30 rounded-full blur-[100px] pointer-events-none"></div>
      <div className="absolute top-0 left-1/2 w-[80%] h-[1px] bg-gradient-to-r from-transparent via-indigo-200 to-transparent opacity-30" />

      {/* --- CONTENT CARD --- */}
      <div className="max-w-lg w-full text-center relative z-10 animate-fade-in-up">
        
        {/* Illustration */}
        <Icons.Ghost />
        
        {/* Code 404 avec Gradient */}
        <h1 className="text-9xl font-black text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-emerald-500 tracking-tighter drop-shadow-sm select-none">
          404
        </h1>
        
        {/* Titre */}
        <h2 className="text-3xl font-bold text-gray-800 mt-4 mb-3">
          {t.pageNotFound || "Page not found"}
        </h2>
        
        {/* Description */}
        <p className="text-gray-500 mb-10 text-lg leading-relaxed px-4">
          {t.pageNotFoundDesc || "Oops! The page you are looking for seems to have wandered off into the digital void."}
        </p>
        
        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link
            to="/"
            className="flex items-center justify-center bg-indigo-600 text-white px-8 py-3 rounded-xl font-semibold hover:bg-indigo-700 transition duration-300 shadow-lg shadow-indigo-200 w-full sm:w-auto transform hover:-translate-y-1"
          >
            <Icons.Home />
            {t.backHome || "Go Home"}
          </Link>

          <button
            onClick={() => window.history.back()}
            className="flex items-center justify-center bg-white border border-indigo-100 text-indigo-600 px-8 py-3 rounded-xl font-semibold hover:bg-indigo-50 hover:border-indigo-200 transition duration-300 w-full sm:w-auto"
          >
            <Icons.ArrowLeft />
            {t.goBack || "Go Back"}
          </button>
        </div>
        
        {/* Message support */}
        <div className="mt-12 border-t border-gray-200/60 pt-6">
             <p className="text-xs text-gray-400">
               {t.errorReport || "If you think this is an error, please contact support."}
             </p>
        </div>
      </div>

      <style jsx>{`
        @keyframes fade-in-up {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes bounce-slow {
          0%, 100% { transform: translateY(-5%); }
          50% { transform: translateY(5%); }
        }
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
        }
        .animate-bounce-slow {
          animation: bounce-slow 3s infinite ease-in-out;
        }
      `}</style>
    </div>
  );
};

export default NotFound;